<template>
    <div class="login-window">
        <div class="content">
            <h3>登录</h3>
            <div
                class="input-wrap user-name"
                :class="{active:params.phone}"
            >
                <input
                    v-model.trim="params.phone"
                    type="text"
                    class="phoneText"
                    maxlength="11"
                    style="width:100%;"
                    autofocus="autofocus"
                    placeholder="手机号"
                >
            </div>
            <div
                v-show="!isType"
                class="input-wrap password"
                :class="{active:params.password}"
            >
                <input
                    v-model.trim="params.password"
                    type="password"
                    class="mimaText"
                    placeholder="密码"
                >
            </div>
            <div
                v-show="isType"
                class="code-wrap flex"
            >
                <div
                    class="input-wrap flex-1 password"
                    :class="{active:params.code}"
                >
                    <input
                        v-model.trim="params.code"
                        type="text"
                        style="width:100%;"
                        maxlength="6"
                        placeholder="验证码"
                    >
                </div>
                <div style="width:118px;">
                    <el-button
                        type="text"
                        :loading="codeLoading"
                        :class="{active:codeText!=='获取验证码'}"
                        @click="handleMsgBtnTap"
                    >
                        {{ codeText }}
                    </el-button>
                </div>
            </div>
            <el-button
                type="primary"
                class="login-btn"
                :loading="loginLoading"
                @click="handleLoginClick"
            >
                登录
            </el-button>
            <div class="switch-type flex">
                <el-button
                    type="text"
                    @click="isType=!isType"
                >
                    {{ isType?'账号密码登录':'短信验证码登录' }}
                </el-button>
                <div>
                    <el-checkbox v-model="params.autoLogin">
                        自动登录
                    </el-checkbox>
                </div>
            </div>
            <span
                class="goRegister"
                @click="goRegister"
            >
                还没有账号？立即注册
            </span>
        </div>
    </div>
</template>
<script>
import { requestSMSCode, verifySMSCode, verifyPassword ,getPubKey} from '@/api/login'
import { valiPhone } from '@/utils/rules'
import { getCookie } from '@/utils'
import mixins from './mixins'
import JSEncrypt from 'jsencrypt'
let timer = null,
    loginTime = null;
export default {
    mixins: [mixins],
    data () {
        return {
            loginLoading: false,
            // 验证码按钮loading
            codeLoading: false,
            // 获取验证码按钮内容
            codeText: '获取验证码',
            // 倒计时总秒数
            time: 60,

            // false === 账号密码 | true === 短信验证码
            isType: false,

            params: {
                phone: '',
                code: '',
                password: '',
                autoLogin: false
            },
        }
    },
    watch: {
        'params.code' (newValue) {
            this.params.code = String(newValue).replace(/[^0-9]/g, '');
        },
        'params.phone' (newValue) {
            this.params.phone = String(newValue).replace(/[^0-9]/g, '');
        },
        'params.autoLogin' (newValue) {
            window.localStorage.autoLogin = newValue;
        }
    },
    created () {
        let isCheck = window.localStorage.autoLogin;
        isCheck = isCheck === 'false' ? false : isCheck;
        this.params.autoLogin = isCheck ? true : false;
    },
    methods: {
        async handleMsgBtnTap () {
            if (this.codeText !== '获取验证码') return;

            if (!(this.params.phone)) {
                this.$$message('请输入手机号', 'error')
                return;
            }
            if (!valiPhone(this.params.phone)) {
                this.$$message('手机号不合法', 'error')
                return;
            }

            this.codeLoading = true;
            try {
                let data = await requestSMSCode({
                    'mobile': this.params.phone,
                    'event': 'login'
                });
                if (data) {
                    this.codeLoading = false;
                    this.$$message(data.msg, 'success')
                    this.params.code = data.data.code;
                } else {
                    this.codeLoading = false;
                    return;
                }
                setTimeout(() => {
                    this.codeLoading = false;
                }, 500);
            } catch (err) {
                this.$$message('获取手机验证码 失败：' + err, 'error')
                setTimeout(() => {
                    this.codeLoading = false;
                }, 500);
                return;
            }

            if (timer) {
                clearInterval(timer);
            }

            this.codeText = this.time + '秒后获取';
            timer = setInterval(async () => {
                this.codeText = --this.time + '秒后获取';
                if (this.time <= 0) {
                    clearInterval(timer);
                    this.time = 60;
                    this.codeText = '获取验证码';
                }
            }, 1000)

        },
        async handleLoginClick () {
            let obj = {
                phone: '请输入手机号',
                code: '请输入验证码',
                password: '请输入密码'
            }
            if (this.isType) {
                delete obj.password
            } else {
                delete obj.code
            }

            for (let key in obj) {
                if (!this.params[key]) {
                    this.$$message(obj[key], 'error')
                    return;
                }
            }

            if (!valiPhone(this.params.phone)) {
                this.$$message('手机号输入不合法', 'error')
                return;
            }

            if (!this.isType && this.params.password.length < 6) {
                this.$$message('密码最小长度是6位', 'error')
                return;
            }

            this.loginLoading = true;
            clearTimeout(loginTime);
            let encryptor = new JSEncrypt() 
            const { code, data } = await getPubKey();
            let rsaPassWord = '';
            let pubKeyId = '';
            if (code === 200) {
                pubKeyId = data.pubKeyId;
                encryptor.setPublicKey(data.pubKey);
                rsaPassWord = encryptor.encrypt(this.params.password)
            }
            console.log('submit!',this.params.password,rsaPassWord);

            this.params.account = this.params.phone;
            let serch = window.location.search ? window.location.search.slice(1).split('&') : ''
            let a = serch[0] && serch[0].includes('redirectURL') ? decodeURIComponent(serch[0].split('=')[1]) : serch[1] && serch[1].includes('redirectURL') ? decodeURIComponent(serch[1].split('=')[1]) : ''
            let b = serch[0] && serch[0].includes('appId') ? serch[0].split('=')[1] : serch[1] && serch[1].includes('appId') ? serch[1].split('=')[1] : ''
            let parameter = Object.assign({}, { 'mobile': this.params.phone, 'password': rsaPassWord, pubKeyId: pubKeyId,'code': this.params.code }, { 'appId': b }, { 'redirectURL': a })
            try {
                let data = await (this.isType ? verifySMSCode(parameter) : verifyPassword(parameter));
                console.log(333,data);
                // 储存手机号
                window.localStorage.loginUserName = this.params.phone;
                if (data) {
                    let info = data.data;
                    this.authentication(info)
                } else {
                    loginTime = setTimeout(() => {
                        this.loginLoading = false;
                    }, 300);
                }
            } catch (err) {
                console.log(444,err);
                return err
            }

        },
        goRegister () {
            setTimeout(() => {
                window.location.href = window.location.origin + '/register?_q=' + getCookie('_q')
            }, 500)
        }
    },
}
</script>
<style lang="scss" scoped>
.login-window {
    width: 461px;
    height: 440px;
    background: #fcfcfc;
    border-radius: 4px;
    /deep/::-webkit-input-placeholder {
        color: rgba(187, 192, 207, 1);
    }
    // h2{
    //     height:42px;
    //     font-size:30px;
    //     font-family:PingFangSC-Medium,PingFang SC;
    //     font-weight:500;
    //     color:rgba(255,255,255,1);
    //     line-height:42px;
    //     margin-bottom: 38px;
    // }
    .content {
        background: #fcfcfc;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
        height: 100%;
        border-radius: 4px;
        padding: 48px 48px 0 48px;
        h3 {
            margin-bottom: 38px;
            width: 60px;
            height: 37px;
            font-size: 26px;
            font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
                '微软雅黑', Arial, sans-serif;
            font-weight: 600;
            color: rgba(11, 21, 39, 1);
            line-height: 37px;
        }
        .input-wrap {
            border: 1px solid rgba(216, 217, 225, 1) !important;
            background: #fcfcfc;
            height: 46px;
            width: 100%;
            padding: 10px 18px;
            box-sizing: border-box;
            // height: 46px;
            // width: 100%;
            // padding: 12px 21px;
            // box-sizing: border-box;
            margin-bottom: 20px;
            &.active {
                border-color: rgba(33, 84, 189, 1);
            }
            input {
                height: 22px;
                font-size: 14px;
                font-family: 'PingFang SC', 'Hiragino Sans GB',
                    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
                font-weight: 400;
                // line-height:22px;
                color: #121c40;
            }
            input::-webkit-search-cancel-button {
                display: none;
            }
            .phoneText {
                padding: 0px 0px 8px 40px;
                background-image: url(../images/phone1.png);
                background-repeat: no-repeat;
                background-position: -5px -2px;
                background-size: 30px 30px;
            }
            .mimaText {
                padding: 0px 0px 8px 40px;
                background-image: url(../images/mima.png);
                background-repeat: no-repeat;
                background-position: -5px -4px;
                background-size: 30px 33px;
            }
        }
        .login-btn {
            background: rgba(33, 84, 189, 1);
            width: 100%;
            border: 0;
            border-radius: 0;
            margin-bottom: 8px;
        }
        .code-wrap {
            align-items: center;
            margin-bottom: 20px;
            button {
                padding: 10px 20px;
                color: rgba(33, 84, 189, 1);
            }
            .input-wrap {
                margin: 0 !important;
            }
            button.active {
                color: #787f95;
            }
        }
        .switch-type {
            justify-content: space-between;
            align-items: center;
            div {
                font-size: 14px;
                font-family: 'PingFang SC', 'Hiragino Sans GB',
                    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
                font-weight: 400;
                color: rgba(120, 127, 149, 1);
                line-height: 20px;
            }
        }
        .goRegister {
            font-size: 14px;
            font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
                '微软雅黑', Arial, sans-serif;
            font-weight: 400;
            color: rgba(33, 84, 189, 1);
            line-height: 60px;
            cursor: pointer;
        }
    }
}
</style>